const en = {
    shareTitle: 'Wallet Basics',
    shareDesc: 'Enjoy the blockchain journey with TokenPocket',
    testUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSf6RLJeV4eE3XGiqTEHr9meUAiNBDzJvfXF7XfQhNMIJfs19Q/viewform?usp=sf_link'
};

export default en;
